import getYouTubeId from 'get-youtube-id';
import * as React from 'react';
import YouTube from 'react-youtube';

import InlineQuote from '_components/InlineQuote';
import ListTitle from '_components/ListTitle';
import ProsConsTable from '_components/ProsConsTable';
import { urlFor } from '_utils/images';

export function ImageComponent({ value }) {
  return (
    <img
      src={urlFor(value)?.url()}
      alt={value.alt || ' '}
      className="mb-8"
      loading="lazy"
    />
  );
}

export function YoutubeComponent({ value }) {
  const { url } = value;
  const id = getYouTubeId(url);
  return (
    <div className="youtube-video-wrapper">
      <YouTube videoId={id} />
    </div>
  );
}

export default {
  block: {
    osquote: ({ children }) => <InlineQuote>{children}</InlineQuote>,
    ostitle: ({ children }) => (
      <div className="mt-8 mb-5">
        <ListTitle showAction={false} fontSize={26}>
          {children}
        </ListTitle>
      </div>
    ),
    h1: ({ children }) => <h1 className="font-bold text-3xl">{children}</h1>,
    h2: ({ children }) => <h2 className="font-bold text-2xl">{children}</h2>,
    h3: ({ children }) => <h3 className="font-bold text-xl">{children}</h3>,
    h4: ({ children }) => <h4 className="font-bold text-lg">{children}</h4>,
    normal: ({ children }) => (
      <p className="text-base leading-7 font-normal">{children}</p>
    ),
  },

  list: (props) => <ul>{props.children}</ul>,
  listItem: (props) => <li>{props.children}</li>,
  types: {
    image: ImageComponent,
    youtube: YoutubeComponent,
    prosConsTable: (props) => <ProsConsTable value={props.value} />,
  },
};
